import { useEffect, useState } from "react";
import {
  Badge, Box, Button, Card, Chip, Stack, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Typography,
} from "@mui/material";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import { messagesApi } from "../api/resources";
import ConversationDialog from "../components/packages/ConversationDialog";
import { useLanguage } from "../i18n/LanguageContext";
import { COLORS } from "../theme";

const courierLabel = (p) => (p.courier === "Otro" && p.courierNote ? `Otro (${p.courierNote})` : p.courier);

export default function MensajesPage() {
  const { t, lang } = useLanguage();
  const [conversations, setConversations] = useState([]);
  const [activePkg, setActivePkg] = useState(null);

  const fmtDateTime = (iso) =>
    new Date(iso).toLocaleString(lang === "en" ? "en-US" : "es-MX", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });

  const load = () => messagesApi.inbox().then(setConversations);

  useEffect(() => {
    load();
    // Abrir esta página cuenta como "revisar" — apaga el badge rojo del menú.
    messagesApi.markChecked();
  }, []);

  return (
    <Box>
      <Typography variant="h5">{t("mensajes.title")}</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        {t("mensajes.subtitle")}
      </Typography>

      <TableContainer component={Card}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ bgcolor: "#F4F5EF" }}>
              <TableCell>{t("panel.colDept")}</TableCell>
              <TableCell>{t("mensajes.colLastMessage")}</TableCell>
              <TableCell>{t("mensajes.colWhen")}</TableCell>
              <TableCell align="right">{t("panel.colAction")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {conversations.length === 0 && (
              <TableRow>
                <TableCell colSpan={4} align="center" sx={{ py: 5, color: "text.secondary" }}>
                  {t("mensajes.empty")}
                </TableCell>
              </TableRow>
            )}
            {conversations.map(({ package: pkg, lastMessage, hasNew }) => (
              <TableRow key={pkg._id} hover sx={hasNew ? { bgcolor: COLORS.brassSoft } : undefined}>
                <TableCell>
                  <Stack direction="row" spacing={0.7} alignItems="center">
                    {hasNew && <Badge color="error" variant="dot" />}
                    <Chip label={pkg.unitId} size="small" sx={{ fontWeight: 600 }} />
                  </Stack>
                </TableCell>
                <TableCell>
                  <Typography variant="body2" fontWeight={hasNew ? 700 : 400}>
                    {pkg.occupantId?.name} — {courierLabel(pkg)} · {pkg.desc}
                  </Typography>
                  <Typography variant="caption" color="text.secondary" noWrap sx={{ display: "block", maxWidth: 420 }}>
                    {lastMessage.senderRole === "staff" ? `${lastMessage.senderName}: ` : ""}{lastMessage.content}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="caption" color="text.secondary">{fmtDateTime(lastMessage.sentAt)}</Typography>
                </TableCell>
                <TableCell align="right">
                  <Button size="small" variant="outlined" startIcon={<ChatBubbleOutlineIcon fontSize="small" />} onClick={() => setActivePkg(pkg)}>
                    {t("mensajes.viewReply")}
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <ConversationDialog pkg={activePkg} onClose={() => setActivePkg(null)} onSent={load} />
    </Box>
  );
}
